import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js'; // For encryption/decryption
import axiosInstance from '../../api/axiosInstance';
// Define the initial state
const initialState = {
  user: null,
  token: null,
  isLoggedIn: false,
  error: null,
  loading: false,
};

// Encryption/Decryption keys
const ENCRYPTION_KEY = 'thgyhtyh5yhgthy5htyhffyrgdmnccbbb4bdbdbdsvvxfgdbbcbbcgfbdcb';

// Utility functions for encryption and decryption
const encryptData = (data) => CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();
const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};
// Async thunk to handle login API call
export const login = createAsyncThunk('login/fetchLogin', async ({loginData,language}, { rejectWithValue }) => {
    const { username, password, rememberMe } = loginData; // Extract rememberMe from loginData
    // Prepare the body for the API request
    const requestBody = {
        username,
        password,
        rememberMe,
        returnUrl: "",
        decvice_id: "",
        device_type: 3,
        device_token: "",
        userType: 1,
    };
  const response = await axiosInstance.post('/api/Common/Login', requestBody, {
    headers: {
      'Content-Type': 'application/json-patch+json',
      "lang": language === "English" ? "2" : "1",
    },
  });
 // Check for a specific error state (e.g., successtate !== 200)
 if (response.data.apiresponseresult.successtate !== 200) {
  return rejectWithValue(response.data.apiresponseresult.errormessage || 'Login failed.');
}
  // Combine token and user data into a single object
  const userData = {
    token: response.data.token,
    user: response.data.apiresponseresult.message,
  };

  // Encrypt the combined data and store it in cookies
  const encryptedData = encryptData(userData);
  Cookies.set('authData', encryptedData, { expires: 7 }); // Save as 'authData' cookie

  return userData;
});
export const logout = createAsyncThunk('logout/fetchLogout', async ({ token}) => {
    const requestBody = {
      "decvice_id": "",
      "device_token": ""
    };
    await axiosInstance.post('/api/Common/Logout', requestBody, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Authorization': `Bearer ${token}`,
      },
    });
  
    // Clear cookies after successful logout
    Cookies.remove('authData');
  });
// Create the slice
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    // Action to restore login state from cookies
    restoreLoginState: (state) => {
      const encryptedData = Cookies.get('authData');
      if (encryptedData) {
        const decryptedData = decryptData(encryptedData);
        state.user = decryptedData.user;
        state.token = decryptedData.token;
        state.isLoggedIn = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isLoggedIn = false;
      });
  },
});

export const { restoreLoginState } = loginSlice.actions;
export default loginSlice.reducer;
